import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1614e574")

_pushScopeId("data-v-1614e574")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { style: {"color":"red"} }, "以上通道根据905协议定义", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.title,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.visible = $event)),
    width: "770px",
    "close-on-click-modal": false,
    onClose: _ctx.onCancel
  }, {
    footer: _withId(() => [
      _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: _ctx.loading,
        onClick: _ctx.onValidate
      }, {
        default: _withId(() => [
          _createTextVNode("确认" + _toDisplayString(_ctx.isType === 'edit' ? '修改' : '添加'), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withId(() => [
      _withDirectives(_createVNode(_component_el_form, {
        model: _ctx.formData,
        ref: "refFrom",
        rules: _ctx.rules,
        "label-width": "130px",
        inline: false
      }, {
        default: _withId(() => [
          _createVNode(_component_el_row, { gutter: 30 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "设备类型:",
                    prop: "deviceType"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.deviceType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.deviceType = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceTypeEnumOption, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "设备厂商:",
                    prop: "deviceFactoryUuid"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.deviceFactoryUuid,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.deviceFactoryUuid = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.factoryList, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.deviceFactoryName,
                              value: item.deviceFactoryUuid
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "设备型号:",
                    prop: "deviceMaintainType"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.deviceMaintainType,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.deviceMaintainType = $event)),
                        placeholder: "请输入",
                        maxlength: "16"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "设备唯一编号:",
                    prop: "deviceMaintainUuid"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.deviceMaintainUuid,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.deviceMaintainUuid = $event)),
                        placeholder: "请输入",
                        disabled: _ctx.isType === 'edit'
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 30 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "监控功能:",
                    prop: "monitorContent"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: _ctx.formData.monitorContent,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.monitorContent = $event))
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.monitorContentOption, (item, key) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: key,
                              label: item.value
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "控车功能:",
                    prop: "carControlContent"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: _ctx.formData.carControlContent,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.carControlContent = $event))
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.carControlContentOption, (item, key) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: key,
                              label: item.value
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "摄像通道:",
                    prop: "cameraContent"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: _ctx.formData.cameraContent,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.cameraContent = $event))
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cameraContentOption, (item, key) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: key,
                              label: item.value
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "报警功能:",
                    prop: "warningContent"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: _ctx.formData.warningContent,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.warningContent = $event))
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.warningContentOption, (item, key) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: key,
                              label: item.value
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "感应功能:",
                    prop: "inductionContent"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: _ctx.formData.inductionContent,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.inductionContent = $event))
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.inductionContentOption, (item, key) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: key,
                              label: item.value
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onClose"]))
})